"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setState = exports.getState = void 0;

/*
 * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */
var state = {
  connectionDelay: 0,
  environment: {},
  logger: false,
  mock: false,
  socket: null,
  authToken: null
};

var getState = function getState() {
  return Object.assign({}, state);
};

exports.getState = getState;

var setState = function setState() {
  var nextState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  state = Object.assign(state, nextState);
  return Promise.resolve();
};

exports.setState = setState;